// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var $$default = Relude_Option.getOrThrow(Curry._1(fromInt, 0));

var admin = Relude_Option.getOrThrow(Curry._1(fromInt, 1));

var iterable = Relude_Option.getOrThrow(Curry._1(fromInt, 2));

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var fromString = include.fromString;

var toString = include.toString;

var decode = include.decode;

var encode = include.encode;

var compare = include.compare;

var eq = include.eq;

var Ord = include.Ord;

var $$Set = include.$$Set;

var $$Map = include.$$Map;

exports.fromInt = fromInt;
exports.fromString = fromString;
exports.toInt = toInt;
exports.toString = toString;
exports.decode = decode;
exports.encode = encode;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.$$Map = $$Map;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.admin = admin;
exports.iterable = iterable;
exports.GraphQL_API = GraphQL_API;
/* include Not a pure module */
